<template>
    <div>
        <b-card
            header="Manage Support Subjects"
            header-text-variant="white"
            header-bg-variant="info"
        >
            <b-row>
                <b-col md="6">
                    <b-form inline class="mb-4">
                        <label class="sr-only" for="subject">Subject</label>
                        <b-input class="mb-2 mr-sm-2 mb-sm-0 f-1" id="subject" type="text" v-model="newSubject"  />
                        <b-button variant="primary" @click.prevent="addSubject">Add Subject</b-button>
                    </b-form>
                </b-col>
            </b-row>

            <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
                <b-row>
                    <b-col md="6">
                        <draggable v-if="form.subjects.length" :list="form.subjects" class="subject-list mb-3">
                            <div v-for="subject in form.subjects" :key="subject.id" class="subject-item">
                                <span class="f-1">{{ subject.subject }}</span>
                                <b-button variant="danger" size="xs" @click="removeSubject(subject)"><i class="fa fa-times"></i></b-button>
                            </div>
                        </draggable>
                        <div v-else class="mb-3">
                            No Subjects
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <b-button variant="success" type="submit">Save Changes</b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: { draggable },
        
        props: {
            subjects: {
                type: Array,
                default() { return [] },
            },
        },

        data() {
            return {
                newSubject: '',
                form: new Form({
                    subjects: [],
                }),
            }
        },
        
        computed: {
        },

        methods: {
            async submit() {
                await this.form.post(`/business/support-subjects`);
            },
            
            addSubject() {
                this.form.subjects.push({
                    subject: this.newSubject,
                    order: this.form.subjects.length,
                    id: Math.random().toString(36).substr(2, 9),
                });

                this.newSubject = '';
            },

            removeSubject(item) {
                this.form.subjects = this.form.subjects.filter(obj => obj.id != item.id);
            },
        },

        mounted() {
        },

        watch: {
            subjects(newVal) {
                this.form.subjects = newVal;
            },
        },
    }
</script>

<style scoped>
.subject-list {
    border: 1px solid #4E778D;
    border-bottom: none;

}

.subject-item {
    display: flex;
    border-bottom: 1px solid #4E778D;
    padding: 1em;
}
.f-1 { flex: 1 }
</style>
